import PropTypes from 'prop-types'
import React from 'react'
import { useSelector } from 'react-redux'
import defaultNavigationConfig from 'constants/navigation'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import Header from 'components/Header'
import Drawer from 'components/Drawer'
import styles from './main-view-layout.module.scss'
import clsx from 'clsx'

const MainLayout = ({ children = null }) => {
  const { user = {} } = useSelector(({ app }) => app)
  const config = defaultNavigationConfig({ user })
  const { xl } = useBreakpoint()

  return (
    <>
      {!xl && (
        <div className={styles['header-container']}>
          <Header />
        </div>
      )}
      <div
        className={clsx(styles['main-wrapper'], {
          [styles['main-wrapper__with-header']]: !xl,
        })}
      >
        {config.length > 0 ? <Drawer>{children}</Drawer> : children}
      </div>
    </>
  )
}

MainLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.oneOf([null]),
  ]),
}

export default MainLayout
